// removed by extract-text-webpack-plugin
module.exports = {"form__control-label":"FormularioUsuario__form__control-label___1LJFS","form__footer":"FormularioUsuario__form__footer___158i7","form__message-error":"FormularioUsuario__form__message-error___1ucTe","form__field--error":"FormularioUsuario__form__field--error___1zatt"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/nominas/nominaIG/components/FormularioUsuario.css
// module id = 914
// module chunks = 0